// eslint-disable-next-line import/no-cycle
import { IReducerState } from 'store/main-reducer';
import { ITokenData } from 'types';

export function getBearerToken(state: IReducerState): string {
  return state.optionsReducer.tokenData?.accessToken || '';
}

export function getTokenData(state: IReducerState): ITokenData | undefined {
  return state.optionsReducer.tokenData;
}
